export var abs = Math.abs;
export var cos = Math.cos;
export var sin = Math.sin;
export var pi = Math.PI;
export var halfPi = pi / 2;
export var tau = pi * 2;
export var max = Math.max;
export var epsilon = 1e-12;



//////////////////
// WEBPACK FOOTER
// ./~/d3-chord/src/math.js
// module id = 169
// module chunks = 0